/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Tax_Code_ReminderInputs */

const vi_order_form_invoice_buyer_tax_code_reminder = /** @type {(inputs: Order_Form_Invoice_Buyer_Tax_Code_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa nhập mã số thuế. Kiểm tra với khách để thông tin công ty trên hóa đơn đầy đủ.`)
};

/**

* @param {Order_Form_Invoice_Buyer_Tax_Code_ReminderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_tax_code_reminder = /** @type {((inputs?: Order_Form_Invoice_Buyer_Tax_Code_ReminderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Tax_Code_ReminderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_tax_code_reminder(inputs)
});